import { useTranslation } from 'react-i18next';
import { useAppStore } from '../../store/useAppStore';
import { useSettingsStore } from '../../store/useSettingsStore';
import { useRole } from '../../hooks/useRole';

function CustomerDetails({ editing = false }) {
  const { t } = useTranslation();
  const role = useRole();
  const form = useSettingsStore((state) => state.form);
  const config = useAppStore((state) => state.config);
  const setForm = useSettingsStore((state) => state.setForm);

  const selectedToppings = Array.isArray(form.toppings) ? form.toppings : [];
  const warningThreshold = parseInt(config?.toppingWarningThreshold || '7', 10);
  const showWarning = selectedToppings.length >= warningThreshold;
  const locked = role === 'anonymous';

  return (
    <>
      <p className="mb-2 text-sm theme-muted">{t('details.halfTip')}</p>
      <label className="flex items-center gap-2.5 text-sm">
        <input
          type="checkbox"
          checked={form.half}
          disabled={locked || editing}
          onChange={(e) => setForm((c) => ({ ...c, half: e.target.checked }))}
          className="h-4 w-4 accent-emerald-400"
        />
        {t('details.half')}
      </label>

      <div>
        <label className="block text-sm font-medium theme-muted">{t('details.name')}</label>
        <input
          className="mt-1.5 w-full rounded-lg border border-[color:var(--app-border)] bg-[color:var(--app-surface)] px-4 py-2.5 outline-none focus:border-emerald-500/60 disabled:cursor-not-allowed disabled:opacity-40"
          value={form.customerName}
          disabled={locked || editing}
          onChange={(e) => setForm((c) => ({ ...c, customerName: e.target.value }))}
          placeholder={t('details.namePlaceholder')}
          required
        />
      </div>

      <div>
        <label className="block text-sm font-medium theme-muted">{t('details.comment')}</label>
        <textarea
          className="mt-1.5 w-full rounded-lg border border-[color:var(--app-border)] bg-[color:var(--app-surface)] px-4 py-2.5 text-sm outline-none focus:border-emerald-500/60 disabled:cursor-not-allowed disabled:opacity-40"
          value={form.comment}
          disabled={locked}
          onChange={(e) => setForm((c) => ({ ...c, comment: e.target.value }))}
          placeholder={t('details.commentPlaceholder')}
        />
      </div>

      {showWarning && (
        <div className="rounded-lg border border-amber-500/40 bg-amber-500/10 px-4 py-2.5 text-sm theme-muted">
          {t('toppings.lessIsMore', { count: selectedToppings.length })}
        </div>
      )}

      <button
        type="submit"
        disabled={locked}
        className={`w-full rounded-lg px-6 py-3 font-semibold transition ${
          locked
            ? 'cursor-not-allowed border border-[color:var(--app-border)] bg-[color:var(--app-surface)] text-[color:var(--app-muted-strong)]'
            : 'bg-emerald-500 text-zinc-950 hover:bg-emerald-400 active:scale-[0.98]'
        }`}
      >
        {t('details.order')}
      </button>
    </>
  );
}

export default CustomerDetails;